// client/src/pages/Admin/ResourceManager/hooks/useToast.ts
import { useState, useCallback, useRef, useEffect } from 'react';
import { Toast } from '../types/resource.types';
import { TOAST_DURATION } from '../constants/resource.constants';

export const useToast = () => {
    const [toasts, setToasts] = useState<Toast[]>([]);

    const timers = useRef<Map<string, number>>(new Map());

    const removeToast = useCallback((id: string) => {
        setToasts(prev => prev.filter(t => t.id !== id));

        const timer = timers.current.get(id);

        if (timer) {
            clearTimeout(timer);
            timers.current.delete(id);
        }
    }, []);

    const showToast = useCallback(
        (
            message: string,
            type: 'success' | 'error' | 'info' = 'info'
        ) => {
            const id = crypto.randomUUID();

            setToasts(prev => [
                ...prev,
                {
                    id,
                    message,
                    type,
                },
            ]);

            const timer = window.setTimeout(() => {
                removeToast(id);
            }, TOAST_DURATION);

            timers.current.set(id, timer);
        },
        [removeToast]
    );

    useEffect(() => {
        return () => {
            timers.current.forEach(clearTimeout);
            timers.current.clear();
        };
    }, []);

    return {
        toasts,
        showToast,
        removeToast,
    };
};